export const filterInput = (type, value) => {
  if (!value) return "";

  switch (type) {
    case "number_only":
      return value.replace(/[^0-9]/g, "");

    case "number_with_dot":
      let cleaned = value.replace(/[^0-9.]/g, "");
      const firstDotIndex = cleaned.indexOf(".");
      if (firstDotIndex !== -1) {
        const beforeDot = cleaned.slice(0, firstDotIndex + 1);
        const afterDot = cleaned.slice(firstDotIndex + 1).replace(/\./g, "");
        return beforeDot + afterDot;
      }
      return cleaned;

    default:
      return value;
  }
};